import invariant from 'invariant';
import { call, put } from 'typed-redux-saga/macro';

import { GetActionByType } from 'Lib/reduxType';
import { withErrorHandling } from 'Lib/sagaHelpers';
import { getServiceFn } from 'Services';
import { PROFILE_SERVICE } from 'Services/constants';

import {
  fetchEmailSubscriptionsError,
  fetchEmailSubscriptionsSuccess,
  updateEmailSubscriptionsError,
  updateEmailSubscriptionsSuccess,
} from './actions';
import { FETCH_EMAIL_SUBSCRIPTIONS, UPDATE_EMAIL_SUBSCRIPTIONS } from './constants';

export const fetchEmailSubscriptionsSaga = withErrorHandling(
  function* fetchEmailSubscriptions(action: GetActionByType<typeof FETCH_EMAIL_SUBSCRIPTIONS>) {
    const { token } = action.payload;
    invariant(token, 'No token supplied');
    const result = yield* call(
      yield* call(getServiceFn, PROFILE_SERVICE, 'fetchEmailSubscriptions' as const),
      token
    );
    const subscriptions = result?.data?.subscriptions?.email;
    yield* put(fetchEmailSubscriptionsSuccess(subscriptions));
  },
  {
    name: 'fetchEmailPreferencesSaga',
    *errorHandler() {
      yield* put(fetchEmailSubscriptionsError());
    },
  }
);

export const updateEmailSubscriptionsSaga = withErrorHandling(
  function* updateEmailSubscriptions(action: GetActionByType<typeof UPDATE_EMAIL_SUBSCRIPTIONS>) {
    const { token, subscriptions } = action.payload;
    invariant(token, 'No token supplied');
    invariant(subscriptions.length, 'No topic supplied');
    yield* call(
      yield* call(getServiceFn, PROFILE_SERVICE, 'updateEmailSubscriptions' as const),
      token,
      subscriptions
    );
    yield* put(updateEmailSubscriptionsSuccess());
  },
  {
    name: 'updateEmailSubscriptionsSaga',
    *errorHandler() {
      yield* put(updateEmailSubscriptionsError());
    },
  }
);
